// The copy for a failure that carries nothing the user can act on -- a network
// error, a response that did not parse, a body the server never populated.
// One string app-wide, so the same failure does not read differently depending
// on which screen it happened on.
export const UNEXPECTED_ERROR_MESSAGE = 'An unexpected error occurred';
